import getField from '@form/formGenerator'

export const sterilizationCitizenCallSaveUrl = `${import.meta.env.VITE_API_URL}/public/sterilization-calls`

export const sterilizationCitizenCallFormObject = {
  id: '',
  addressResponsibleFullName: '',
  addressResponsibleCellPhone: '',
  addressResponsibleEmail: '',
  sterilizationAddress: '',
  sterilizationCity: '',
  sterilizationZipCode: '',
  sterilizationDistrict: '',
  nestsNumber: '',
  comment: '',
  isTreatmentNotificationActive: '',
  isResponsibilityAssumed: '',
  mission: '',
  callType: 'citizen',
  userCoordinates: '',
  freeCode: '',
  local: window.localStorage.getItem('local'),
  nuisances: ''
}

const sterilizationCitizenCallFormFields = (
  step = null,
  sterilizationCitizenCallFormObject,
  updateFormObject,
  updateFormObjectProp,
  errors,
  saveForm,
  checkMyAddress,
  isBilled,
  isLoading,
  t,
  data,
  cost,
  renderCost
) => {
  let fields = []
  fields['caller'] = [{
    type: 'text',
    name: 'addressResponsibleFullName',
    label: t('form.full_name'),
    value: sterilizationCitizenCallFormObject.addressResponsibleFullName,
    key: 'sterilizationCitizenCallFormObject-addressResponsibleFullName',
    cssClass: 'column is-12',
    isRequired: true
  },
  {
    type: 'text',
    name: 'addressResponsibleCellPhone',
    label: t('form.cell_phone'),
    value: sterilizationCitizenCallFormObject.addressResponsibleCellPhone,
    key: 'sterilizationCitizenCallFormObject-addressResponsibleCellPhone',
    cssClass: 'column is-12',
    isRequired: true
  },
  {
    type: 'email',
    name: 'addressResponsibleEmail',
    label: t('form.email'),
    value: sterilizationCitizenCallFormObject.addressResponsibleEmail,
    key: 'missionMairieFormObject-addressResponsibleEmail',
    cssClass: 'column is-12'
  }, {
    type: 'select',
    name: 'sterilizationDistrict',
    label: t('form.district'),
    value: sterilizationCitizenCallFormObject.sterilizationDistrict,
    key: 'sterilizationCitizenCallFormObject-sterilizationDistrict',
    cssClass: 'column is-6',
    withIcon: false,
    options: data.districts,
    disabled: false,
    error: [],
    isRequired: true
  }, {
    type: 'number',
    name: 'sterilizationZipCode',
    label: t('form.zip_code'),
    value: sterilizationCitizenCallFormObject.sterilizationZipCode,
    key: 'sterilizationCitizenCallFormObject-sterilizationZipCode',
    cssClass: 'column is-6',
    isRequired: true
  }, {
    type: 'text',
    name: 'sterilizationAddress',
    label: t('form.address'),
    value: sterilizationCitizenCallFormObject.sterilizationAddress,
    key: 'missionMairieFormObject-sterilizationAddress',
    cssClass: 'column is-12',
    isRequired: true
  },
  {
    type: 'text',
    name: 'freeCode',
    label: t('form.free_code'),
    value: sterilizationCitizenCallFormObject.freeCode,
    key: 'sterilizationCitizenCallFormObject-freeCode',
    cssClass: `column is-12 ${!isBilled ? 'is-hidden' : ''}`,
    isRequired: false,
    help: t('form.free_code_help')
  }]
  fields['call'] = [{
    type: 'number',
    name: 'nestsNumber',
    label: t('form.nests_number'),
    value: sterilizationCitizenCallFormObject.nestsNumber,
    key: 'sterilizationCitizenCallFormObject-nestsNumber',
    cssClass: 'column is-12',
    disabled: false,
    error: [],
    isRequired: isBilled
  }, {
    type: 'checkbox',
    name: 'nuisances',
    label: t('labels.select_nuisances'),
    value: sterilizationCitizenCallFormObject.nuisances,
    key: 'sterilizationCitizenCallFormObject-nuisances',
    cssClass: `column is-12 ${data.nuisances && data.nuisances.length ? '' : 'is-hidden'}`,
    options: data.nuisances,
    isMultiple: true
  }, {
    type: 'function',
    callback: renderCost,
    cssClass: 'column is-12',
    key: 'sterilizationCitizenCallFormObject-cost-show',
  }, {
    type: 'textarea',
    name: 'comment',
    label: t('form.comment'),
    value: sterilizationCitizenCallFormObject.comment,
    key: 'missionMairieFormObject-comment',
    cssClass: 'column is-12'
  }, {
    type: 'switcher',
    name: 'isTreatmentNotificationActive',
    label: t('form.is_treatment_notification_active'),
    value: sterilizationCitizenCallFormObject.isTreatmentNotificationActive,
    cssClass: 'column is-12',
    key: 'sterilizationCitizenCallFormObject-isTreatmentNotificationActive',
  }, {
    type: 'switcher',
    name: 'isResponsibilityAssumed',
    label: t('form.is_responsibility_assumed'),
    help: t('form.help_is_responsibility_assumed'),
    value: sterilizationCitizenCallFormObject.isResponsibilityAssumed,
    cssClass: 'column is-12',
    key: 'sterilizationCitizenCallFormObject-isResponsibilityAssumed',
    isRequired: true
  }, {
    type: 'switcher',
    name: 'isDataStoreAccepted',
    label: t('form.is_data_store_accepted'),
    help: t('form.help_is_data_store_accepted'),
    value: sterilizationCitizenCallFormObject.isDataStoreAccepted,
    cssClass: 'column is-12',
    key: 'sterilizationCitizenCallFormObject-isDataStoreAccepted',
    isRequired: true
  }, {
    type: 'button',
    buttons: true,
    callback: sterilizationCitizenCallFormObject.addressValidated ? saveForm : checkMyAddress,
    cancel: false,
    validateText: sterilizationCitizenCallFormObject.addressValidated
      ? (cost ? t('actions.validate_pay_request') : t('actions.validate_request'))
      : t('actions.check_my_address'),
    cssClassParent: 'column is-12',
    cssClassValidate: 'button is-blue',
    validateIcon: 'icon-done',
    key: 'sterilizationCitizenCallFormObject-form',
    isLoading
  },
  {
    type: 'hidden',
    name: 'id',
    value: parseInt(sterilizationCitizenCallFormObject.id),
    key: 'sterilizationCitizenCallFormObject-id'
  },
  {
    type: 'hidden',
    name: 'mission',
    value: parseInt(sterilizationCitizenCallFormObject.mission),
    key: 'sterilizationCitizenCallFormObject-missionid'
  },
  {
    type: 'hidden',
    name: 'callType',
    value: 'citizen',
    key: 'sterilizationCitizenCallFormObject-callType'
  },
  {
    type: 'hidden',
    name: 'userCoordinates',
    value: sterilizationCitizenCallFormObject.userCoordinates,
    key: 'sterilizationCitizenCallFormObject-userCoordinates'
  }]

  if (null === step) {
    fields = [...fields['caller'], ...fields['call']]
  }

  return fields[step].map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}

export default sterilizationCitizenCallFormFields

